import { AxiosResponse } from 'axios';
import { ProjectDetailResponse, ProjectListResponse, PositionTypeQuery } from 'types/entity';
import { ProjectResponse } from 'types/entity/project-response';
import { ProjectAndAdditionalInfoResponse } from 'types/entity/project-and-additional-info-response';
import { http } from './settings';

const addPositionTypeQuery = (url: string, positionType?: PositionTypeQuery) => {
  const delimiter = url.indexOf('?') >= 0 ? '&' : '?';
  return `${url}${positionType ? `${delimiter}position_type=${positionType}` : ''}`;
};

export const fetchDefaultProject = (positionType?: PositionTypeQuery): Promise<ProjectAndAdditionalInfoResponse> => {
  const url = addPositionTypeQuery('/projects/working', positionType);
  return http.get(url).then((value: AxiosResponse<ProjectAndAdditionalInfoResponse>) => value.data);
};

export const postDefaultProject = (projectId: string): Promise<ProjectAndAdditionalInfoResponse> => http.post(`/projects/${projectId}/working`);

export const fetchProject = (projectId: string, positionType?: PositionTypeQuery): Promise<ProjectResponse> => {
  const url = addPositionTypeQuery(`/projects/${projectId}`, positionType);
  return http.get(url).then((value: AxiosResponse<ProjectResponse>) => value.data);
};

export const fetchProjectDetail = (selectedProjectId: string): Promise<ProjectDetailResponse> => http.get(`/projects/${selectedProjectId}/details`)
  .then((value: AxiosResponse<ProjectDetailResponse>) => value.data);

export const fetchProjectList = (positionType?: PositionTypeQuery): Promise<ProjectResponse[]> => {
  const url = addPositionTypeQuery('/projects', positionType);
  return http.get(url).then((value: AxiosResponse<ProjectListResponse>) => value.data.projects || []);
};
